import { Outlet } from "react-router-dom";

import RouteSeo from "../components/RouteSeo";
import FloatingChat from "../ui/whatsappicon";

const MainLayout = () => {
  return (
    <div className="relative min-h-screen">
      <RouteSeo />

      {/* Rutas hijas */}
      <main id="main-content" className="min-h-screen">
        <Outlet />
      </main>

      {/* Chat flotante GLOBAL */}
      <FloatingChat 
        phone="+51944320015"
        message="Hola!, Me gustaria alquilar una cabaña. Porfavor brindeme mayor información"
      />
    </div>
  );
};

export default MainLayout;
